import React, { useState, useEffect } from 'react'
import Search from '../../PageComponents/Search/Search';
import InvoiceEditor from './InvoiceEditor'
import apiService from '../../Services/apiServices';
import globals from '../../Services/globals';
import { ToastProvider, useToasts } from 'react-toast-notifications';

const AddInvoice = (params) => {
    const { addToast } = useToasts();
    const [name, setName] = useState();
    const [text, setText] = useState();
    const [settings, setSettings] = useState();
    const [partner, setParner] = useState();
    const id = params.match.params.id;

    const save = () => {
        if (id) {
            apiService().put('invoicesTemplates', { id: id ? id : 0, name: name, text: text })
                .then(response => {
                    if (response.success) {
                        responseMessage(response.success ? 'success' : '', 'U ruajt me sukses!');
                    }
                    else {
                        responseMessage('error', 'Ka ndodhur një gabim!')
                    }
                })
        }
        else {
            apiService().post('invoicesTemplates', { id: id ? id : 0, name: name, text: text })
                .then(response => {
                    if (response.success) {
                        responseMessage(response.success ? 'success' : '', 'U ruajt me sukses!');
                        window.location.href = '#/edit-invoice/' + response.data.id;
                    }
                    else {
                        responseMessage('error', 'Ka ndodhur një gabim!')
                    }
                })
        }
    }

    const getSettings = () => {
        globals().getSettings().then((response) => {
            if (response) {
                let sett = response;
                setSettings(sett)
            }
        })
    }

    const responseMessage = (appearance, message) => {
        addToast(message, { appearance: appearance, autoDismiss: true, });
    }

    const getTemplate = (id) => {
        apiService().query('getInvoiceTemplate', 'id=' + id)
            .then(response => {
                if (response.success) {
                    console.log(response)
                    setName(response.data[0].name)
                    setText(response.data[0].text)
                }
            })
    }

    const copyTag = (e) => {
        navigator.clipboard.writeText(e.target.innerHTML);
    }

    const tags = ["invoiceNo", "totalSum", "vatSum", "companyName", "fiscalNumber", "city", "phoneNo", "accNo", "date", "partner_companyName", "partner_fiscalNo", "partner_businessNo", "vatNo"]

    const generateTagButton = () => {

        return tags?.map(tag => {
            console.log(tag)
            return <div className='tooltip-tag'><button type='button' className='btn-tag' id={tag} onClick={(e) => copyTag(e)}>
                {`@${tag}`}
            </button>
                <small class="tooltiptext">Click to copy {`@${tag}`}</small>
            </div>
        })
    }

    const replaceText = (contractTemplate, sale) => {
        let text = contractTemplate;
        let data = sale;// Object.assign(sale, sale?.Contract)

        tags?.forEach((tag, key) => {

            if (tag === 'Image') {
                console.log(tag, imageTag(data[tag.toString()]))
                text = text.replaceAll("@" + tag, data[tag.toString()] ? <img src={data[tag.toString()]} /> : "--");
            }
            else {
                text = text.replaceAll("@" + tag, data[tag.toString()] ? data[tag.toString()] : "--");
            }

        })
        return text;
    }

    const imageTag = (src) => {
        return <img src={src} />
    }

    const towordDoc = (filename = '', contractTemplate, sale, saleData) => {
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var body = saleData?.map((item) => `
                <tr>
                <td>${item.id}</td>
                <td>${item.itemName}</td>
                <td>${item.barcode}</td>
                </tr>
            `);
        var html = header + replaceText(contractTemplate, sale) + footer;
        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        filename = filename ? filename + '.doc' : 'document.docx';
        var downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        }
        else {
            downloadLink.href = url;
            downloadLink.download = filename;
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

    const getSaleDetails = (sale) => {
        apiService().query('getSaleDetails', 'saleId=' + sale.id)
            .then((response) => {
                console.log(response)
                if (response.success) {
                    let merge = Object.assign(sale, response.data)
                    merge = Object.assign(merge, settings)
                    merge = Object.assign(merge, partner)
                    console.log(merge)
                    towordDoc('test_print', text, sale, response.data)
                }
            })
    }

    const getPartner = (sale) => {
        apiService().query('partner', 'id=' + sale.partnerId)
            .then((response) => {
                if (response.success) {
                    let a = response.data[0];
                    const b = {};
                    Object.keys(a).forEach(k => b[`partner_${k}`] = a[k]);
                    console.log(b);
                    setParner(b)
                    getSaleDetails(sale)
                } else {
                    console.log('Error:' + response.errorMessage);
                }
            });
    }

    const testPrint = () => {
        apiService().query('getSale', 'id=' + 1071)
            .then((response) => {
                console.log(response)
                if (response.success) {
                    let sale = response.data[0]
                    getPartner(sale)
                }
            })
    }

    useEffect(() => {
        getSettings()
        if (id) {
            getTemplate(id)
        }
    }, [])

    return (
        <div className='px-4 py-2'>
            <Search save={() => save()} printClick={() => testPrint()} />
            <div className='mt-2'>
                <input value={name} name='name' type='text' className='form-control mb-2' placeholder='Emertimi' onChange={(e) => setName(e.target.value)} />
                <div style={{ overflow: 'hidden' }}>
                    <small style={{ fontStyle: 'italic' }}>Perdorni tagat {generateTagButton()} per te lexuar te dhanat nga sistemi!</small>
                </div>
                <InvoiceEditor name="Text" value={text} getBackData={(text) => setText(text)} />
            </div>
        </div>
    )
}

export default AddInvoice